import React, { Component } from 'react';
import styled from 'styled-components';
import throttle from 'lodash.throttle';

import FlexBox from '../../../components/FlexBox';
import Icon from '../../../components/Icon';
import { setScrollTop } from '../../../utils/scroll';


const Container = styled(FlexBox)`
  position: fixed;
  right: 15px;
  bottom: 78px;
  visibility: ${({ visible }) => visible === 'show' ? 'visivle' : 'hidden'};
  .drop-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background:rgba(51,51,51,1);
    opacity:0.76;
    border-radius:3px;
  }
`;

type Props = {
  info: Object,
  locale: string,
  i18n: Object,
};


export default class extends Component<Props> {
  _throttleScroll = throttle(this._scroll.bind(this), 300)

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  state = {
    visible: 'hide',
  }

  componentDidMount() {
    this.clientHeight = window.innerHeight || document.documentElement.clientHeight;
    window.addEventListener('scroll', this._throttleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._throttleScroll);
  }


  _scroll() {
    const preVisible = this.state.visible;
    const newVisible = (document.documentElement.scrollTop || document.body.scrollTop) > this.clientHeight ? 'show' : 'hide';
    newVisible !== preVisible && (this.setState({ visible: newVisible }));
  }

  handleClick() {
    setScrollTop(document.documentElement, 0);
    setScrollTop(document.body, 0);
  }

  render() {
    const { visible } = this.state;
    return (
      <Container visible={visible}>
        <span
          onClick={this.handleClick}
          onKeyPress={this.handleClick}
          className="drop-item"
          role="button"
          tabIndex={0}
        >
          <Icon type="shangjiantou" color="#ffffff" />
        </span>
      </Container>
    );
  }
}
